export type WordCase = 'им' | 'род' | 'дат' | 'вин' | 'твор' | 'пред';

/**
 * Получить часть слова в соответсвии с переданным падежом
 *
 * @param wordCase нужный падеж
 * @param stringsList список частей слова [а,ой,у, ,ом]
 */
export const getNecessaryCase = (wordCase: WordCase = 'им', stringsList: string | string[]) =>
    (typeof stringsList === 'string' ? stringsList.split(',') : stringsList)[casesList.indexOf(wordCase)].trim();

const casesList = ['им', 'род', 'дат', 'вин', 'твор', 'пред'] as const;
